import { render, staticRenderFns } from "./safeWorkPermitDetailAppr.vue?vue&type=template&id=4e8d42fa"
import script from "./safeWorkPermitDetailAppr.vue?vue&type=script&lang=js"
export * from "./safeWorkPermitDetailAppr.vue?vue&type=script&lang=js"
import style0 from "./safeWorkPermitDetailAppr.vue?vue&type=style&index=0&id=4e8d42fa&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8d42fa')) {
      api.createRecord('4e8d42fa', component.options)
    } else {
      api.reload('4e8d42fa', component.options)
    }
    module.hot.accept("./safeWorkPermitDetailAppr.vue?vue&type=template&id=4e8d42fa", function () {
      api.rerender('4e8d42fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/swp/safeWorkPermitDetailAppr.vue"
export default component.exports